import { Fragment, useEffect, useRef } from 'react';

import gsap from 'gsap/dist/gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useTranslation } from 'next-i18next';

gsap.registerPlugin(ScrollTrigger);

export const ServiceAbout: React.FC<{ translationKey: string }> = ({ translationKey }) => {
  const { t } = useTranslation('pageServices');
  const el = useRef(null);

  useEffect(() => {
    gsap.to('#about', {
      y: 0,
      opacity: 1,
      duration: 2,
      scrollTrigger: {
        scrub: true,
        start: 'top 100%',
        end: 'top 60%',
        trigger: '#about',
      },
    });
    gsap.to('#about-title', {
      y: 0,
      opacity: 1,
      duration: 1,
      scrollTrigger: { start: 'top 100%', end: 'top 80%', trigger: '#about', scrub: true },
    });
    gsap.to('#about-content-1', {
      y: 0,
      opacity: 1,
      duration: 1,
      scrollTrigger: { start: 'top 60%', end: 'top 30%', trigger: '#about', scrub: true },
    });
    gsap.to('#about-content-2', {
      y: 0,
      opacity: 1,
      duration: 1,
      scrollTrigger: { start: 'top 50%', end: 'top 20%', trigger: '#about', scrub: true },
    });
    gsap.to('#about-content-3', {
      y: 0,
      opacity: 1,
      duration: 2,
      scrollTrigger: { start: 'top 40%', end: 'top 10%', trigger: '#about', scrub: true },
    });
  }, []);

  const sections = t(`serviceSingle.${translationKey}.about.sections`, {
    returnObjects: true,
  }) as any;

  return (
    <section
      ref={el}
      id="about"
      className="bg-gradient flex min-h-[100vh] w-full items-center overflow-hidden  py-20 md:py-28 lg:py-36">
      <div className="container grid grid-cols-2 gap-2">
        <div
          id="about-title"
          className="col-span-2 mb-6 translate-y-[400px] opacity-0 lg:col-span-1">
          <h2
            id="about-subtitle"
            className="text-heading-about mb-4 font-black md:mb-4"
            dangerouslySetInnerHTML={{ __html: t(`serviceSingle.${translationKey}.about.title`) }}
          />
        </div>

        {sections?.map((item: any, index: number) => (
          <div
            key={`about-content-${index + 1}`}
            id={`about-content-${index + 1}`}
            className="col-span-2 flex translate-y-[260px] flex-col items-start justify-start bg-white/5 p-4 py-8 opacity-50 lg:col-span-1 lg:p-8">
            <h3
              className="text-heading-item mb-4 border-b-[1px] border-gray-100/70 pb-5 pr-10 text-primary"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            <div dangerouslySetInnerHTML={{ __html: item.text }} />
          </div>
        ))}
      </div>
    </section>
  );
};
